export default __webpack_public_path__ + "static/ab-kwe-logo-b23dbb34bac0d13f251bc7398eceafd0.svg";